import {
  takeEvery,
  call,
  put,
} from "redux-saga/effects";
import { showErrorNotification, showSuccessNotification } from "store/notifications/actions";
import {
  fetchIbAgreements,
  fetchIbProducts,
  postMasterIb,
  patchMasterIb,
  postSharedIb,
  patchSharedIb,
  deleteIbAgreement
} from "apis/ib-agreements";
import { getDictionary } from "apis/dictionary";
import { mergeIbProductCategories } from "common/productCategories";
import {
  FETCH_IB_AGREEMENTS_START,
  FETCH_IB_PRODUCTS_START,
  ADD_MASTER_IB_AGREEMENT_START,
  UPDATE_MASTER_IB_AGREEMENT_START,
  ADD_SHARED_IB_AGREEMENT_START,
  UPDATE_SHARED_IB_AGREEMENT_START,
  DELETE_IB_AGREEMENT_START,
} from "./actionTypes";
import {
  fetchAgreementsSuccess,
  fetchProductsSuccess,
  createMasterIbAgreementSuccess,
  updateMasterIbAgreementSuccess,
  createSharedIbAgreementSuccess,
  apiError,
  deleteIbAgreementSuccess,
  updateSharedIbAgreementSuccess,
} from "./actions";

function* getIbAgreements({ payload }) {
  try {
    const { result } = yield call(fetchIbAgreements, payload);
    yield put(fetchAgreementsSuccess(result));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getIbProducts() {
  try {
    const { result } = yield call(fetchIbProducts);
    const dictionary = yield call(getDictionary);
    const dictionaryProducts = dictionary?.result?.[0]?.products || {};
    yield put(fetchProductsSuccess(mergeIbProductCategories(result, dictionaryProducts)));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* addMasterIbAgreement({ payload }) {
  try {
    const response = yield call(postMasterIb, payload);
    const result = response?.result;
    const isError = response?.isError;
    const message = response?.message;
    if (result && !isError) {
      yield put(createMasterIbAgreementSuccess(result));
      yield put(showSuccessNotification("Master IB agreement added successfully!"));
    } else {
      const errText = message || "Failed to add master IB agreement.";
      yield put(apiError(errText));
      yield put(showErrorNotification(errText));
    }
  } catch (error) {
    const errText = error?.message || "Failed to add master IB agreement.";
    yield put(apiError(errText));
    yield put(showErrorNotification(errText));
  }
}

function* updateMasterIbAgreement({ payload }) {
  try {
    const response = yield call(patchMasterIb, payload);
    const result = response?.result;
    const isError = response?.isError;
    const message = response?.message;
    if (result && !isError) {
      yield put(updateMasterIbAgreementSuccess(result));
      yield put(showSuccessNotification("Master IB agreement edited successfully!"));
    } else {
      const errText = message || "Failed to edit master IB agreement.";
      yield put(apiError(errText));
      yield put(showErrorNotification(errText));
    }
  } catch (error) {
    const errText = error?.message || "Failed to edit master IB agreement.";
    yield put(apiError(errText));
    yield put(showErrorNotification(errText));
  }
}

function* addSharedIbAgreement({ payload }) {
  try {
    const response = yield call(postSharedIb, payload);
    const result = response?.result;
    const isError = response?.isError;
    const message = response?.message;
    if (result && !isError) {
      yield put(createSharedIbAgreementSuccess(result));
      yield put(showSuccessNotification("Shared IB agreement added successfully!"));
    } else {
      const errText = message || "Failed to add shared IB agreement.";
      yield put(apiError(errText));
      yield put(showErrorNotification(errText));
    }
  } catch (error) {
    const errText = error?.message || "Failed to add shared IB agreement.";
    yield put(apiError(errText));
    yield put(showErrorNotification(errText));
  }
}
function* updateSharedIbAgreement({ payload }) {
  try {
    const response = yield call(patchSharedIb, payload);
    const result = response?.result;
    const isError = response?.isError;
    const message = response?.message;
    if (result && !isError) {
      yield put(updateSharedIbAgreementSuccess(result));
      yield put(showSuccessNotification("Shared IB agreement edited successfully!"));
    } else {
      const errText = message || "Failed to edit shared IB agreement.";
      yield put(apiError(errText));
      yield put(showErrorNotification(errText));
    }
  } catch (error) {
    const errText = error?.message || "Failed to edit shared IB agreement.";
    yield put(apiError(errText));
    yield put(showErrorNotification(errText));
  }
}

function * deleteAgreement({ payload }){
  try {
    yield call(deleteIbAgreement, payload);
    yield put(deleteIbAgreementSuccess(payload));
    yield put(showSuccessNotification("Agreement has been deleted successfully!"));
  } catch (error){
    yield put(showErrorNotification(error?.message ?? "Something went wrong"));
    yield put(apiError("An error happned during deleting the agreement"));
  }
}

function* IbAgreementSaga() {
  yield takeEvery(FETCH_IB_AGREEMENTS_START, getIbAgreements);
  yield takeEvery(FETCH_IB_PRODUCTS_START, getIbProducts);
  yield takeEvery(ADD_MASTER_IB_AGREEMENT_START, addMasterIbAgreement);
  yield takeEvery(UPDATE_MASTER_IB_AGREEMENT_START, updateMasterIbAgreement);
  yield takeEvery(ADD_SHARED_IB_AGREEMENT_START, addSharedIbAgreement);
  yield takeEvery(UPDATE_SHARED_IB_AGREEMENT_START, updateSharedIbAgreement);
  yield takeEvery(DELETE_IB_AGREEMENT_START, deleteAgreement);
}

export default IbAgreementSaga;
